<ul>
  <li>
    <p style="margin-bottom: 10px;">
      <span
        ><span style="color: #00b0f0;"><span style=""><span lang="en-GB"><strong>Target</strong></span></span></span><span
          style="color: #00b0f0;"><span style=""><span lang="en-GB">: </span></span></span
        ><span style="color: #404040;"
          ><span style=""
            ><span lang="en-GB"
              >If YTD is selected: Target for the number of active boluses at the end of the current month. Else: target for the number of
              active boluses at the end of the year of the selected timeframe.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p style="margin-bottom: 10px;">
      <span
        ><span style="color: #404040;"><span style=""><span lang="en-GB"><strong>Actual</strong></span></span></span><span
          style="color: #404040;"
          ><span style=""
            ><span lang="en-GB"
              >: If YTD is selected: The actual number of active boluses or else the number of active boluses at the end of the selected
              year.</span
            ></span
          ></span
        ></span
      >
    </p>
  </li>
  <li>
    <p>
      <span style="color: #92d050;">●</span><span
        ><span style="color: #404040;"><span style=""><span lang="en-GB">/</span></span></span><span style="color: #ffc000;"
          ><span lang="en-GB"><strong>●</strong></span></span
        ><span style="color: #404040;"
          ><span style=""
            ><span lang="en-GB">: The icon next to the number of active boluses indicates, whether the target is met (</span></span
          ></span
        ><span style="color: #92d050;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span style=""><span lang="en-GB">) or missed (</span></span></span
        ><span style="color: #ffc000;"><span lang="en-GB"><strong>●</strong></span></span><span style="color: #404040;"
          ><span style=""><span lang="en-GB">)</span></span></span
        ></span
      >
    </p>
  </li>
</ul>
<p lang="en-GB">&nbsp;</p>
<p>Chart:</p>
<p>
  &nbsp;&nbsp;&nbsp;&nbsp;<img
    class="img1"
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAHCAYAAACC5PR5AAAAMElEQVR4nGPZ//q3w45XfzwYBgFgOfH+r0Xn7Z/lA+0QEGAZaAcgg1HH4AKjjsEFAGiKC6hW9SILAAAAAElFTkSuQmCC"
    alt=""
  />&nbsp;&nbsp;&nbsp;Active boluses target
</p>
<p>
  &nbsp;&nbsp;&nbsp;&nbsp;<img style="background-color: #afcb08; height:2px; width: 11px;" />&nbsp;&nbsp;&nbsp;Active boluses
  month-to-month/quarter-to-quarter connect-ion line
</p>
<p>
  &nbsp;&nbsp;&nbsp;&nbsp;<img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAF0lEQVR4nGNZf5rjPwMewIJPclQBCQoAqjICruMPtt0AAAAASUVORK5CYII="
    alt=""
  />&nbsp;&nbsp;&nbsp;&nbsp;Active boluses in month / end of quarter / end of half-year
</p>
<p style="margin-bottom:10px;">
  &nbsp;&nbsp;&nbsp;&nbsp;<img
    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAAGElEQVR4nGO5efPmfwY8gAWf5KgCEhQAAB9aA7c57FzIAAAAAElFTkSuQmCC"
    alt=""
  />&nbsp;&nbsp;&nbsp;&nbsp;Active boluses previous year
</p>

<style>
  p {
    padding: 0;
    margin: 0;
  }

  .img1 {
    width: 11px;
    height: 2px;
  }
</style>
